import "./style.scss"
import { useEffect, useState } from "react";
import { Modal } from 'antd';
import { Radio, message } from 'antd';
import { goWhatsApp } from "../../utils/data/index";
const IntermediatePage = ({ isShow, onClose }) => {


    const [isModalOpen, setIsModalOpen] = useState(isShow);
    const [grade, setGrade] = useState(null);
    const [subject, setSubject] = useState(null);
    useEffect(() => {
        setIsModalOpen(isShow);
    }, [isShow]);

    const handleOk = () => {
        console.log("grade", grade);
        console.log("subject", subject);
        if (grade && subject) {
            setIsModalOpen(false);
            let name = grade + "-" + subject;
            goWhatsApp(name);
            if (onClose) {
                onClose();
            }
        } else {
            // 提示
            message.warning("请选择年级和科目");
        }

    };
    const handleCancel = () => {
        setIsModalOpen(false);
        if (onClose) {
            onClose();
        }
    };
    return (
        <div className="intermediatePage">
            <Modal
                title=""
                closable={true}
                open={isModalOpen}
                footer={null}
                onCancel={handleCancel}
            >
                <div className="modal-content">
                    <h2 className="modal-title">免费预约试听课</h2>
                    <div className="line"></div>
                    <Radio.Group
                        name="grade"
                        className="radio-group"
                        value={grade}
                        onChange={(e) => setGrade(e.target.value)}
                    >
                        <Radio value={'K2-K3'}>K2-K3</Radio>
                        <Radio value={'P1-P6'}>P1-P6</Radio>
                        <Radio value={'S1-S3'}>S1-S3</Radio>
                    </Radio.Group>
                    <div className="line"></div>
                    <Radio.Group
                        name="subject"
                        className="radio-group"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    >
                        <Radio value={'中文'}>中文</Radio>
                        <Radio value={'数学'}>数学</Radio>
                        <Radio value={'英语'}>英语</Radio>
                    </Radio.Group>
                    <div className="line"></div>
                    <button className="green-button" onClick={handleOk}>立即领取免费试听</button>
                </div>
            </Modal>
        </div >
    )
}
export default IntermediatePage;